import { render, staticRenderFns } from "./OptimizeCard.vue?vue&type=template&id=7a9e2a6b&scoped=true"
import script from "./OptimizeCard.vue?vue&type=script&lang=js"
export * from "./OptimizeCard.vue?vue&type=script&lang=js"
import style0 from "./OptimizeCard.vue?vue&type=style&index=0&id=7a9e2a6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9e2a6b",
  null
  
)

export default component.exports